export default "__VITE_ASSET__Cw8gpb93__"